// Rotas do sistema interno, todas embaixo de um prefixo único.
//
// O prefixo não é enfeite: é o contrato com o Apache. O .htaccess do servidor
// entrega o index.html apenas para /app e seus subcaminhos, e deixa o Apache
// 404ar todo o resto - é isso que faz URL inexistente responder 404 de verdade
// em vez de servir a landing com 200 (o "soft 404" que o Google trata como
// conteúdo de baixa qualidade).
//
// Como a regra do servidor é `^app(/.*)?$`, ela cobre qualquer rota nova daqui
// de dentro sem edição nenhuma no servidor. Rota interna nova = só mexer neste
// arquivo. Ver docs/htaccess-servidor.md.
//
// O que fica FORA do /app é o site público: / (a landing) e /blog/... (arquivos
// estáticos reais). Página pública nova aí sim exige atenção ao servidor.
export const APP_BASE = '/app'

export const ROUTES = {
  login: `${APP_BASE}/login`,
  dashboard: `${APP_BASE}/dashboard`,
  patients: `${APP_BASE}/patients`,
  sessions: `${APP_BASE}/sessions`,
  plans: `${APP_BASE}/plans`,
  therapists: `${APP_BASE}/therapists`,
  accountability: `${APP_BASE}/accountability`,
  games: `${APP_BASE}/games`,
  themes: `${APP_BASE}/themes`,
  acervo: `${APP_BASE}/acervo`,
  // Landing antiga, substituída pela V2 em junho/2026. Mantida atrás do
  // prefixo para consulta: não é linkada de lugar nenhum e, aqui dentro, sai
  // do índice do Google junto com o resto do sistema.
  landingAntiga: `${APP_BASE}/home1`,
} as const
